import { Button, TextField } from '@mui/material';
import React, { useState } from 'react';
import { TodoInputWrapper } from '../style/styles';

interface TodoInputProps {
    onAdd: (text: string) => void;
}

const TodoInput: React.FC<TodoInputProps> = ({ onAdd }) => {
    const [newTodo, setNewTodo] = useState('');

    const handleAdd = () => {
        if (newTodo.trim()) {
            onAdd(newTodo.trim());
            setNewTodo('');
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleAdd();
        }
    };

    return (
        <TodoInputWrapper>
            <TextField
                fullWidth
                multiline
                value={newTodo}
                onChange={(e) => setNewTodo(e.target.value)}
                placeholder="Add new todo"
                onKeyDown={handleKeyPress}
                size="small"
                sx={{
                    backgroundColor: 'background.paper',
                    '& .MuiOutlinedInput-root': {
                        padding: '8px 14px',
                    },
                }}
            />
            <Button
                variant="contained"
                onClick={handleAdd}
                disabled={!newTodo.trim()}
                sx={{ alignSelf: 'flex-start' }}
            >
                Add
            </Button>
        </TodoInputWrapper>
    );
};

export default TodoInput; 